define( function() {
	"use strict";

	// Only count HTML whitespace
	// Other whitespace should count in values
	// https://infra.spec.whatwg.org/#ascii-whitespace
	return ( /[^\x20\t\r\n\f]+/g );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/rnothtmlwhite.js
// module id = 40
// module chunks = 0